module.exports = __webpack_public_path__ + "img/diesel-locomotive-03.84b99084.png";